/** @jsxImportSource @emotion/react */

import { Form } from 'react-final-form'
import React from 'react'
import Button from '@mui/material/Button'
import { useMutation } from '@apollo/client'
import { validateRequiredHtml } from 'utils/validation'
import { EditorField } from 'components/Editor'
import { findAllCanadianDatTips_findAllCanadianDatTip_items as CanadianDatTip } from '__generatedTypes__/findAllCanadianDatTips'
import { updateCanadianDatTip, updateCanadianDatTipVariables } from '__generatedTypes__/updateCanadianDatTip'
import { UPDATE_CANADIAN_DAT_TIP } from 'queries/canadianDatTips'
import * as classes from './styles'

export type EditFormProps = {
  canadianDatTip: CanadianDatTip
}

export const EditForm = ({ canadianDatTip }: EditFormProps) => {
  const [updateCanadianDatTip] = useMutation<updateCanadianDatTip, updateCanadianDatTipVariables>(
    UPDATE_CANADIAN_DAT_TIP
  )

  const handleSubmit = async (values: CanadianDatTip) => {
    await updateCanadianDatTip({
      variables: {
        input: {
          id: canadianDatTip.id,
          title: canadianDatTip.title,
          description: values.description,
        },
      },
    })
  }

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={canadianDatTip}
      render={({ handleSubmit, submitting }) => (
        <form css={classes.form} onSubmit={handleSubmit}>
          <EditorField
            type="default"
            label="Description"
            name="description"
            placeholder="Enter Description"
            validate={validateRequiredHtml}
          />
          <Button variant="contained" type="submit" color="blue" size="large" disabled={submitting} fullWidth>
            Save Edits
          </Button>
        </form>
      )}
    />
  )
}
